import React from "react";
import AjoutProjectForm from "./AjoutProjectForm";

function AjoutProjetClient() {
  return (
    <div className="flex justify-center">
      <div className="w-[92%] mt-4 p-8 max-md:w-full max-md:p-5">
        <div className="header flex flex-col space-y-3 text-center pb-6">
          <h1 className="text-3xl text-black/90 font-bold">
            Présentez votre projet, Transformons votre idée en réalité !
          </h1>
          <p className="font-mandali text-base text-indigos border-b ">
            Vous avez un projet, une idée que vous voulez concrétiser ? faites
            le nous savoir...
          </p>
        </div>
        <div className="py-3 px-6 bg-white border rounded-3xl">
          <AjoutProjectForm />
        </div>
      </div>
    </div>
  );
}

export default AjoutProjetClient;
